// Menyu: biznes turiga va ruxsatga qarab. Brendbuk: yon panelda 9 tadan ko'p band yo'q — qolgani "Yana"da.

/** @typedef {{ to: string, group: "asosiy"|"moliya"|"jamoa"|"hujjat", label: string, icon: string, permission: string, kinds?: string[] }} NavItem */

export const GROUP_LABELS = {
  asosiy: "Asosiy",
  moliya: "Moliya",
  jamoa: "Jamoa",
  hujjat: "Hujjat va sozlama",
};

/** @type {NavItem[]} */
export const NAV = [
  { to: "/", group: "asosiy", label: "Bugun", icon: "home", permission: "reports:read" },
  {
    to: "/pos",
    group: "asosiy",
    label: "Kassa",
    icon: "kassa",
    permission: "sales:write",
    kinds: ["dokon", "onlayn", "xizmat", "umumiy"],
  },
  {
    to: "/orders",
    group: "asosiy",
    label: "Buyurtmalar",
    icon: "bag",
    permission: "orders:read",
    kinds: ["onlayn", "dokon", "umumiy"],
  },
  {
    to: "/bookings",
    group: "asosiy",
    label: "Yozilish",
    icon: "calendar",
    permission: "bookings:read",
    kinds: ["xizmat"],
  },
  { to: "/products", group: "asosiy", label: "Tovarlar", icon: "box", permission: "catalog:read" },
  { to: "/customers", group: "asosiy", label: "Mijozlar", icon: "users", permission: "crm:read" },
  {
    to: "/invoices",
    group: "moliya",
    label: "Hisob-fakturalar",
    icon: "file",
    permission: "invoicing:read",
    kinds: ["it", "xizmat", "startap", "umumiy", "onlayn"],
  },
  { to: "/money", group: "moliya", label: "Pul", icon: "wallet", permission: "finance:read" },
  {
    to: "/projects",
    group: "asosiy",
    label: "Loyihalar",
    icon: "clock",
    permission: "projects:read",
    kinds: ["it", "startap", "xizmat"],
  },
  { to: "/team", group: "jamoa", label: "Jamoa", icon: "team", permission: "hr:read" },
  { to: "/reports", group: "moliya", label: "Hisobot", icon: "chart", permission: "reports:read" },
  { to: "/sales", group: "asosiy", label: "Cheklar", icon: "file", permission: "sales:read" },
  { to: "/stock", group: "asosiy", label: "Ombor harakati", icon: "box", permission: "inventory:read" },
  {
    to: "/subscriptions",
    group: "moliya",
    label: "Obunalar",
    icon: "repeat",
    permission: "subscriptions:read",
  },
  { to: "/payroll", group: "jamoa", label: "Oylik", icon: "wallet", permission: "payroll:read" },
  { to: "/leave", group: "jamoa", label: "Taʼtil", icon: "calendar", permission: "leave:read" },
  { to: "/okr", group: "jamoa", label: "Maqsadlar", icon: "target", permission: "okr:read" },
  { to: "/budget", group: "moliya", label: "Byudjet", icon: "pie", permission: "budget:read" },
  {
    to: "/equity",
    group: "moliya",
    label: "Ulushlar",
    icon: "pie",
    permission: "equity:read",
    kinds: ["startap", "it"],
  },
  { to: "/edo", group: "hujjat", label: "Hujjatlar (EDO)", icon: "stamp", permission: "edo:read" },
  { to: "/tax", group: "hujjat", label: "Soliq", icon: "tax", permission: "tax:read" },
  { to: "/bank", group: "moliya", label: "Bank", icon: "bank", permission: "banking:read" },
  { to: "/audit", group: "hujjat", label: "Jurnal", icon: "log", permission: "audit:read" },
  { to: "/settings", group: "hujjat", label: "Sozlamalar", icon: "settings", permission: "members:read" },
];

/** @param {string|undefined} kind @param {(p:string)=>boolean} can */
export function navFor(kind, can) {
  const all = NAV.filter((n) => can(n.permission));
  const primary = all.filter((n) => !n.kinds || n.kinds.includes(kind ?? "umumiy")).slice(0, 9);
  const rest = all.filter((n) => !primary.includes(n));
  return { primary, rest, tabs: primary.slice(0, 4) };
}
